import { createSlice } from '@reduxjs/toolkit';
// import axios from '../../../axios';
// import { AUTH_TOKEN } from '../../../environments';
import { moduleName } from '../moduleInfo';
// import { getAllReviewsForSchoolRoute } from '../utils/apiRoutes';

// export const getAllReviewsForSchoolAsync = createAsyncThunk(
//   `${moduleName}/getAllReviewsForSchoolAsync`,
//   async (payload) => {
//     // const { schoolId,page,rating } = payload;
//     const response = await axios({
//       method: 'GET',
//       url: getAllReviewsForSchoolRoute(),
//       headers: {
//         Authorization: AUTH_TOKEN,
//       },
//       params: {
//         ...payload,
//       },
//     });
//     const data = response.data;
//     return data;
//   }
// );

const dashboardSlice = createSlice({
  name: `${moduleName}/dashboard`,
  initialState: {
    loading: false,
    data: '',
  },
  reducers: {
    storeDashboardSchoolId: (state, action) => {
      state.schoolId = action.payload;
    },
  },
  extraReducers: {
    // [getDashboardPanelAsync.pending]: (state) => {
    //   state.loading = true;
    // },
    // [getDashboardPanelAsync.fulfilled]: (state, action) => {
    //   state.loading = false;
    //   state.dashboardPanel = action.payload.data;
    // },
    // [getDashboardPanelAsync.rejected]: (state) => {
    //   state.loading = false;
    // },
  },
});

export const { storeDashboardSchoolId } = dashboardSlice.actions;

export default dashboardSlice.reducer;
